export async function qrCodeToDataURL(code, options) {
  const { default: qrcode } = await import('qrcode');
  return await qrcode.toDataURL(code, options);
}
